/**
 * Thread API items are newest-first; buildComposeDraftFields expects oldest→newest
 * so deepestEmail = last element is the latest message (#335).
 */

/** Timeline sort key for compose quoting (oldest → newest). */
export function emailTimelineTime(email) {
  const raw = email?.sent_at || email?.created_at || email?.date
  const t = raw ? Date.parse(raw) : NaN
  return Number.isFinite(t) ? t : 0
}

/** Sort emails oldest→newest for compose quote/To/Cc assembly. */
export function emailsInComposeTimelineOrder(emails) {
  return (emails || [])
    .slice()
    .sort((a, b) => {
      const dt = emailTimelineTime(a) - emailTimelineTime(b)
      if (dt !== 0) return dt
      return (Number(a?.id) || 0) - (Number(b?.id) || 0)
    })
}
